import axios from 'axios'
import EventHub from '../event-hub'
import store from '../../store'

const baseUrl = process.env.VUE_APP_API_URL
const api = axios.create({
  baseURL: baseUrl
})
api.CancelToken = axios.CancelToken
api.isCancel = axios.isCan

api.interceptors.request.use((config) => {
  let user = JSON.parse(localStorage.getItem('user'))
  if (user) {
    config.headers.Authorization = `Bearer ${user.access_token}`;
  }
  return config;
})

api.interceptors.response.use(response => {
  return response;
}, error => {
    if (error.response && error.response.status === 401) {
      EventHub.$emit('showAlertNotification', `You are not authorized to perform this action. Please login with an account that is authorized to continue. ${error.response.data}`);
    }
    else {
      let title =
        (error.response && error.response.statusText) ||
        'Oops!';

      let message =
        (error.response && error.response.data) ||
        error.message ||
        'An unspecified error occurred. Please try again or contact ResMan Support.';

      if (error.response && error.response.data) {
        title = error.response.data.title || title;

        if (error.response.data.errors) {
          message = error.response.data.errors[""] || error.response.data.errors;
        }

        if (error.response.data.FailureReasons) {
          message = error.response.data.FailureReasons[""] || error.response.data.FailureReasons;
        }
      }

      if (Array.isArray(message)) {
        message = message.join(' ');
      }

      console.debug(title, message);
      store.dispatch('activateErrorDialog', { message: message, title: title });
    }
    return Promise.reject(error);
});

export default api
